import Path from './route/Path';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap';

function App() {
  return (
    <div>
      <Path/>
    </div>
  );
}

export default App;
